import { render, staticRenderFns } from "./ChapterCard.vue?vue&type=template&id=277f6af1&scoped=true&"
import script from "./ChapterCard.vue?vue&type=script&lang=js&"
export * from "./ChapterCard.vue?vue&type=script&lang=js&"
import style0 from "./ChapterCard.vue?vue&type=style&index=0&id=277f6af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277f6af1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VIcon,VImg,VProgressLinear})
